import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserAccountService } from '../_services/user-account.service';

@Component({
  selector: 'app-user-confirm',
  templateUrl: './user-confirm.component.html',
  styleUrls: ['./user-confirm.component.css']
})
export class UserConfirmComponent implements OnInit {

  public confirmSuccess: boolean = false;

  constructor(
    private actRoute: ActivatedRoute,
    public userService: UserAccountService)
  {
    var userId = this.actRoute.snapshot.params.userid;
    var confirmationCode = this.actRoute.snapshot.params.confirmationcode;

    userService.confirmUser(userId, confirmationCode).then((result) => {
      if (result.Success) {
        this.confirmSuccess = true;
      }
      else {
        
      }
    },
      (err) => {

    });
  }

  ngOnInit(): void {
  }

}
